import { FileSpreadsheet, CheckCircle2, AlertTriangle, Clock, EyeOff, FileWarning, ArrowLeftRight, Timer } from "lucide-react";

const CARD = "bg-white border border-[#E2E8F0] rounded-sm p-4 transition-colors";

function Kpi({ testid, label, value, sub, icon: Icon, accent, onClick, active }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={onClick}
      className={`${CARD} text-left hover:bg-slate-50 ${active ? "ring-2 ring-[#2563EB] ring-offset-1" : ""}`}
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] uppercase tracking-[0.05em] font-semibold text-slate-500">{label}</span>
        <Icon size={15} style={{ color: accent }} />
      </div>
      <div className="mt-2 font-mono text-3xl font-light tabular-nums" style={{ color: accent || "#0F172A" }}>
        {value}
      </div>
      {sub && <div className="text-[11px] text-slate-400 mt-1 font-mono">{sub}</div>}
    </button>
  );
}

export function KpiStrip({ summary, slaSummary, activeStatus, activeSla, onPickStatus, onPickSla }) {
  const s = summary || {};
  const sla = slaSummary || {};
  const pick = (code) => () => onPickStatus(activeStatus === code ? null : code);
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-8 gap-4" data-testid="kpi-strip">
      <Kpi testid="kpi-total-importados" label="Importados" value={s.total_imported ?? 0}
        sub={`${s.matched_orders ?? 0} órdenes match`} icon={FileSpreadsheet} accent="#0F172A"
        onClick={() => onPickStatus(null)} active={!activeStatus && !activeSla} />
      <Kpi testid="kpi-conciliados" label="Conciliados" value={s.conciliado ?? 0}
        icon={CheckCircle2} accent="#059669" onClick={pick("CONCILIADO")} active={activeStatus === "CONCILIADO"} />
      <Kpi testid="kpi-diferencia" label="Con Diferencia" value={s.diferencia ?? 0}
        icon={AlertTriangle} accent="#DC2626" onClick={pick("DIFERENCIA")} active={activeStatus === "DIFERENCIA"} />
      <Kpi testid="kpi-pendientes" label="Pendiente STORIS" value={s.pendiente_storis ?? 0}
        icon={Clock} accent="#D97706" onClick={pick("PENDIENTE_STORIS")} active={activeStatus === "PENDIENTE_STORIS"} />
      <Kpi testid="kpi-solo-ui" label="Solo en UI" value={s.existe_ui_no_reporte ?? 0}
        icon={EyeOff} accent="#64748B" onClick={pick("EXISTE_UI_NO_REPORTE")} active={activeStatus === "EXISTE_UI_NO_REPORTE"} />
      <Kpi testid="kpi-incompletos" label="Incompletos" value={s.datos_incompletos ?? 0}
        icon={FileWarning} accent="#EA580C" onClick={pick("DATOS_INCOMPLETOS")} active={activeStatus === "DATOS_INCOMPLETOS"} />
      <Kpi testid="kpi-fuera-sla" label="Fuera de SLA" value={sla.fuera_sla ?? 0}
        sub={`${sla.en_riesgo ?? 0} en riesgo`} icon={Timer} accent="#BE123C"
        onClick={() => onPickSla(activeSla === "FUERA_SLA" ? null : "FUERA_SLA")} active={activeSla === "FUERA_SLA"} />
      <Kpi testid="kpi-transfer-regular" label="Transfer / Regular"
        value={`${s.transfer_deliveries ?? 0}/${s.regular_deliveries ?? 0}`}
        sub="transfer · regular" icon={ArrowLeftRight} accent="#2563EB" onClick={() => {}} />
    </div>
  );
}
